module.exports = __webpack_public_path__ + "img/welcome_new.8ed135f0.jpg";